module.exports = __webpack_public_path__ + "static/media/up_arrow_icon.4968db0d.svg";